import { useState, useEffect } from "react";
import { OPERATOR_MANAGEMENT_SERVICE } from "src/utils/Api";
import { mockData } from "src/Pages/User/Role/List";
import __ from "src/utils/Translations";
import sendBatchRequests from "src/utils/Api/sendBatchRequests";

export default function useOperatorRoles(asOption = false, idAsIri = false) {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () =>
      sendBatchRequests({
        idAsIri,
        asOption,
        IRI_PREFIX,
        requestParams: {
          service: OPERATOR_MANAGEMENT_SERVICE,
          path: "/operator-roles",
          method: "GET",
          mockData,
          itemsPerPage: 100,
        },
        setData,
      });

    fetchData();
  }, [idAsIri, asOption, setData]);

  return data;
}

export const IRI_PREFIX = "/api/operator-management/v1/rest/operator-roles";
